import { ActiveMixin } from '@umbraco-ui/uui-base/lib/mixins';
import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let UUISymbolSortElement = class extends ActiveMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.descending = false;
  }
  render() {
    return html`<svg
        id="up"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M 255.125 400.35 L 88.193 188.765 H 422.055 Z"></path>
      </svg>
      <svg id="down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M 255.125 400.35 L 88.193 188.765 H 422.055 Z"></path>
      </svg>`;
  }
};
UUISymbolSortElement.styles = [
  css`
      :host {
        position: relative;
        display: inline-block;
        width: 0.8em;
        height: 1em;
        vertical-align: middle;
        pointer-events: none;
      }

      svg {
        position: absolute;
        left: 0;
        top: 50%;
        width: 0.8em;
        fill: currentColor;
        transform-origin: 50% 50%;
        transition:
          transform 120ms ease-in-out,
          opacity 120ms,
          margin-top 240ms;
        opacity: 0;
        margin-top: -0.5em;
      }

      #up {
        transform: rotate(180deg);
        margin-top: -0.7em;
      }
      #down {
        margin-top: -0.3em;
      }
      :host([active]) #up {
        margin-top: calc(-0.5em - (0.2em * var(--uui-symbol-sort-hover, 0)));
      }
      :host([active]) #down {
        margin-top: calc(-0.5em + (0.2em * var(--uui-symbol-sort-hover, 0)));
      }

      :host(:hover) {
        --uui-symbol-sort-hover: 1;
      }
      :host(:not([active])) #up,
      :host(:not([active])) #down {
        opacity: calc(0.25 * var(--uui-symbol-sort-hover, 0));
      }

      :host([active]:not([descending])) #down {
        opacity: 1;
      }
      :host([active]:not([descending])) #up {
        opacity: calc(0.25 * var(--uui-symbol-sort-hover, 0));
      }

      :host([active][descending]) #up {
        opacity: 1;
      }
      :host([active][descending]) #down {
        opacity: calc(0.25 * var(--uui-symbol-sort-hover, 0));
      }
    `
];
__decorateClass([
  property({ type: Boolean, reflect: true })
], UUISymbolSortElement.prototype, "descending", 2);
UUISymbolSortElement = __decorateClass([
  defineElement("uui-symbol-sort")
], UUISymbolSortElement);

export { UUISymbolSortElement };
